<template>
  <div
    class="floating-cart"
    :class="{ 'avoid-footer': avoidFooter }"
    @click="goToCotizacion"
  >
    <img
      src="@/assets/images/logos/cotiza-aqui-button.png"
      alt="Cotiza Aquí"
      class="cart-image"
    />
    <span class="cart-counter" v-if="productosSeleccionados.length >= 0">
      {{ productosSeleccionados.length }}
    </span>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";
import { useCotizacionStore } from "@/store/cotizacion";

export default {
  name: "FloatingCart",
  data() {
    return {
      avoidFooter: false,
    };
  },
  computed: {
    productosSeleccionados() {
      return storeToRefs(useCotizacionStore()).productosSeleccionados.value;
    },
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.avoidFooter = entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0.01,
      }
    );

    const footer = document.querySelector("footer");
    if (footer) observer.observe(footer);
  },
  methods: {
    goToCotizacion() {
      this.$router.push("/contactos");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@700&display=swap");

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
}

.floating-cart {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  cursor: pointer;
  animation: float 3s ease-in-out infinite;
  transition: bottom 3s ease;
}

/* Evita solaparse con el footer (desktop) */
.floating-cart.avoid-footer {
  bottom: 700px; /* o el valor que tú consideres adecuado */
  transition: bottom 3s ease;
}

/* Evita solaparse con el footer (móvil) */
@media (max-width: 768px) {
  .floating-cart.avoid-footer {
    bottom: 1000px; /* ajústalo al alto de tu footer en móvil */
  }
}

.cart-image {
  height: 60px;
  width: auto;
  display: block;
  position: relative;
}
.cart-counter {
  position: absolute;
  top: 8px;
  right: 14%; /* <-- en vez de 6px o 10px */
  transform: translateX(50%); /* <-- centra el contenido según su ancho */
  color: rgb(255, 102, 0);
  font-family: "Orbitron", sans-serif;
  font-weight: bold;
  font-size: 15px;
  pointer-events: none;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
@media (max-width: 600px) {
  .floating-cart {
    bottom: 15px;
    right: 15px;
  }

  .cart-image {
    height: 45px; /* Más pequeño en celulares */
  }

  .cart-counter {
    top: 5px;
    right: 12%;
    font-size: 13px; /* Más pequeño y legible */
  }
}
</style>
s
